import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { queryKeys } from "../../lib/queryKeys";
import { getGraphData } from "../../services";

export const useGraphData = (
  params: Record<string, unknown>,
  enabled = true
) =>
  useQuery({
    queryKey: queryKeys.graphData(params),
    queryFn: () => getGraphData(params),
    enabled,
    placeholderData: keepPreviousData,
  });
